import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-settings-3-line',
    title: 'Sondermaschinenbau',
    description:
      'Individuelle Maschinen, Vorrichtungen und technische Systeme nach Kundenanforderung – von der Konzeption bis zur schlüsselfertigen Übergabe.',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Steuerungstechnik / SPS',
    description:
      'Planung, Verdrahtung, SPS-Programmierung (Siemens, Beckhoff, OMRON) und Integration in bestehende Produktionsprozesse.',
  },
  {
    icon: 'ri-robot-line',
    title: 'Automation & Handling',
    description:
      'Handlingsysteme, pneumatische Abläufe, Transfersysteme und Prozessautomatisierung – auch mit Industrieroboter-Integration.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Bildverarbeitung & Entwicklung',
    description:
      'Industrielle Bildverarbeitungssysteme zur Qualitätssicherung, Fehlererkennung und Prüftechnik in der Fertigung.',
  },
  {
    icon: 'ri-home-gear-line',
    title: 'Gebäudeautomation',
    description:
      'Als Loxone Partner planen und installieren wir intelligente Gebäudeautomation und Sicherheitstechnik für Gewerbe und Industrie.',
  },
  {
    icon: 'ri-shield-line',
    title: 'Sicherheitstechnik',
    description:
      'Planung und Umsetzung von Sicherheitslösungen für Maschinen und Anlagen – normgerecht und zuverlässig.',
  },
];

const CompanyServices = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Leistungen</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4">
            Was wir für Sie tun
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            Von der Idee bis zur fertigen Anlage – wir begleiten Ihr Projekt mit technischer Kompetenz und persönlichem Einsatz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-[#F8FAFC] border border-gray-100 rounded-xl p-7 hover:border-[#1E3A8A]/20 hover:bg-white transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#EFF6FF] rounded-xl mb-5">
                <i className={`${service.icon} text-[#1E3A8A] text-xl`}></i>
              </div>
              <h3 className="text-gray-900 font-semibold text-base mb-2">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/leistungen"
            className="inline-flex items-center gap-2 bg-[#1E3A8A] hover:bg-[#1e40af] text-white font-semibold px-7 py-3.5 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Alle Leistungen im Detail
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CompanyServices;
